import TwitterComponent from "../components/socialglass/post_components/TwitterComponent";
import YoutubeComponent from "../components/socialglass/post_components/YoutubeComponent";
import InstagramComponent from "../components/socialglass/post_components/InstagramComponent";
import TikTokComponent from "../components/socialglass/post_components/TikTokComponent";

function MediaComponent({
  postId,
  username,
  index,
  idToData,
  videoRefs,
  handleManualMute,
  handleManualUnmute,
  muted = true,
  caption = "",
  showIcon = true,
  isAutoPlay = true,
  rounded = false,
  metaData = false,
}) {
  const mediaInfo = idToData[postId];

  if (!mediaInfo) {
    return <p>Media not found</p>;
  }

  const platform = mediaInfo.platform.toLowerCase();

  console.log(
    "current platform in media component: ",
    platform,
    "Media info: ",
    mediaInfo,
  );
  console.log("Creator name: ", username);

  const commonProps = {
    url: mediaInfo.url,
    downloaded_path: mediaInfo.downloaded_path,
    muted,
    creatorName: username,
    videoRef: (el) => {
      if (el) {
        videoRefs.current[index] = el;
      } else {
        delete videoRefs.current[index];
      }
    },
    caption,
    handleManualMute,
    handleManualUnmute,
    isAutoPlay,
    rounded,
    metaData,
  };

  switch (platform) {
    case "tiktok":
      return (
        <TikTokComponent type="tiktok" {...commonProps} showIcon={showIcon} />
      );

    case "instagram":
      return (
        <InstagramComponent
          type="instagram"
          {...commonProps}
          showIcon={showIcon}
        />
      );

    case "youtube":
      return <YoutubeComponent {...commonProps} />;

    case "twitter":
      return <TwitterComponent {...commonProps} showIcon={showIcon} />;

    default:
      return <p>Platform not supported</p>;
  }
}

export default MediaComponent;
